import { fetcher } from "helpers/fetcher";

import {
  TUpdatetStaffAcademicAndQualificationReq,
  TUpdatetStaffAcademicAndQualificationRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updatetStaffAcademicAndQualification = async (
  payload: TUpdatetStaffAcademicAndQualificationReq
) => {
  return await fetcher<
    TUpdatetStaffAcademicAndQualificationRes,
    TUpdatetStaffAcademicAndQualificationReq["data"]
  >(ENDPOINT.USER.UPDATE_STAFF_ACADEMIC_QUALIFICATION, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.USER.UPDATE_STAFF_ACADEMIC_QUALIFICATION.version,
      [API_HEADER.USER_ID]: payload.idUser,
    },
  });
};

export const mutationUpdatetStaffAcademicAndQualification = async (
  payload: TUpdatetStaffAcademicAndQualificationReq
) => {
  return (await updatetStaffAcademicAndQualification(payload)).data;
};

mutationUpdatetStaffAcademicAndQualification._key = (
  payload: TUpdatetStaffAcademicAndQualificationReq
) => [ENDPOINT.USER.UPDATE_STAFF_ACADEMIC_QUALIFICATION.url, payload];
